import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Design-system font-size tokens live under `--text-*` in `@theme`, which makes
 * Tailwind emit `text-body-m`, `text-caption`, etc. Default `twMerge` treats those
 * as colour utilities and drops them when a `text-text-*` / `text-odds-*` class is
 * also present — so teach it they are font sizes.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-l',
            'display-m',
            'heading-l',
            'heading-m',
            'heading-s',
            'body-l',
            'body-m',
            'body-s',
            'label-m',
            'label-s',
            'odds',
            'caption',
          ],
        },
      ],
    },
  },
});

/** Joins class names and lets later Tailwind utilities win over earlier conflicting ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
